<!--
* @Author: zhangping
* @Date: 2025-09-26 15:24:27
* @Description: 发货弹框
-->

<template>
    <Modal v-model="isShow" title="发货" :mask-closable="false" @on-cancel="onCancel">
        <Form ref="formRef" :model="formData" :rules="formRule" :label-width="120" label-colon class="pr-30">
            <FormItem label="物流单号" prop="logisticsNo">
                <Input v-model="formData.logisticsNo" placeholder="请输入" style="width: 100%" />
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="onCancel">取消</Button>
            <Button type="primary" :loading="loadings.save" @click="onOk"> 确定 </Button>
        </div>
    </Modal>
</template>

<script>
import { apiOrderSendProduct } from '@/api/purchase';
export default {
    data() {
        return {
            isShow: false,
            id: null,
            formData: { logisticsNo: '' },
            formRule: {
                logisticsNo: [{ required: true, message: '请输入物流单号', trigger: 'change' }],
            },
            loadings: { save: false },
        };
    },
    methods: {
        open(id) {
            this.isShow = true;
            this.id = id;
        },
        onCancel() {
            this.isShow = false;
            this.$refs['formRef'].resetFields();
        },
        onOk() {
            console.log('onOk');
            this.$refs['formRef'].validate(async (valid) => {
                if (valid) {
                    const params = {
                        id: this.id,
                        logisticsNo: this.formData.logisticsNo,
                    };
                    const res = await apiOrderSendProduct(params);
                    this.$Message.success('发货成功');
                    this.onCancel();
                }
            });
        },
    },
};
</script>

<style lang="less" scoped></style>
